import Template from './EventSummary.njk';
import Marionette from "backbone.marionette";
import ExperienceView from "../experience";
import ExperiencePriceView from "../experience_price";
import moment from "moment-timezone";
import { Config } from "../../application/Config";
import { EventSummaryQuantityView } from "./EventSummary/EventSummaryQuantityView";
import "./EventSummary.less";

export const EventSummaryView = Marionette.View.extend({
  template: Template,
    className: "EventSummaryView",
    tagName: 'tr',
    regions: {
        quantity: ".availability",
        experience: ".experience",
        price: ".price"
    },

    modelEvents: {
        'change:guides': 'onGuidesChange',
        'change:open': 'onGuidesChange',
        'change:quantity': 'onGuidesChange'
    },

    initialize(options) {
        this.settings = options.settings;
    },

    getAvailabilityClass() {
        const open = this.model.get("open");
        if (open === 0) {
            return "full";
        }

        const experience = this.model.get('experience'),
            max = this.model.get('max');

        if (max) {
            let percentage = open / max * 100;

            if (percentage <= 25) {
                if (percentage <= 10 || open == 1) {
                    return "almost-full";
                }
                else {
                    return "half-full";
                }
            }
            else {
                return "available"
            }
        }
        else {
            if (open > 2) {
                return "available";
            }
            else {
                return open == 2 ? "half-full" : "almost-full";
            }
        }
    },

    templateContext() {
        var slots;
        if (this.settings.events.availability == "available") {
            slots = this.model.get("open") < 99998 ? this.model.get("open") : '&infin;';
        }
        else {
            slots = this.model.get("quantity") ? this.model.get("quantity").reserved : 0;
        }

        var now = moment.tz(Config.timezone);

        return {
            startTime: this.model.get("start").format("LT"),
            isToday: this.model.get("start").date() == now.date(),
            openSlots: slots,
            availability: this.getAvailabilityClass(),
            availabilityText: this.settings.events.availability == "available" ? "Available" : "Reserved"
        }
    },

    onRender() {
        this.showChildView("quantity", new EventSummaryQuantityView({
            model: this.model,
            settings: this.settings
        }));
        this.showChildView("experience", new ExperienceView({
            model: this.model.get('experience'),
            guides: this.model.get("guides"),
            event: this.model,
            settings: this.settings
        }));
        if (Config.display.get("config").events.showPrice) {
            this.showChildView("price", new ExperiencePriceView({
                model: this.model.get('experience'),
                start: this.model.get("start")
            }));
        }
    },

    onGuidesChange() {
        this.showChildView("experience", new ExperienceView({
            model: this.model.get('experience'),
            guides: this.model.get("guides"),
            event: this.model,
            settings: this.settings
        }));
    }
});



// WEBPACK FOOTER //
// ./src/js/view/components/EventSummary.js